__turbopack_context__.v({
  "carouselContainer": "styles-module__8RCE1G__carouselContainer",
  "headerRow": "styles-module__8RCE1G__headerRow",
  "imgContainer": "styles-module__8RCE1G__imgContainer",
  "link": "styles-module__8RCE1G__link",
  "scrollableRowContainer": "styles-module__8RCE1G__scrollableRowContainer",
  "text": "styles-module__8RCE1G__text",
  "textContainer": "styles-module__8RCE1G__textContainer",
});
